// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2TVRV","inner":"Form_inner__1XXTd","range":"Form_range__2zB26","name":"Form_name__SwXwC","actions":"Form_actions__2-5rA"};